export default __webpack_public_path__ + "static/media/QPR.1bffcc48.png";